var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCloudFlash = function SvgCloudFlash(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9998 27.8122C42.536 27.1021 43.8292 25.9556 44.7183 24.5156C45.6074 23.0756 46.0531 21.4058 45.9998 19.7142C45.981 18.4478 45.7072 17.1981 45.1945 16.0399C44.6818 14.8817 43.9409 13.8388 43.016 12.9734C42.0911 12.1081 41.0012 11.4381 39.8115 11.0035C38.6218 10.569 37.3567 10.3787 36.0918 10.4442C34.9748 8.19615 33.2494 6.30667 31.1117 4.9907C28.9741 3.67472 26.51 2.98508 23.9998 3.00021C20.6375 2.9551 17.3845 4.19391 14.904 6.46413C12.4234 8.73435 10.902 11.8651 10.6498 15.2182C9.62084 14.992 8.55453 14.9969 7.5277 15.2325C6.50087 15.4681 5.53909 15.9285 4.7117 16.5807C3.8843 17.2329 3.2119 18.0605 2.74294 19.0038C2.27399 19.9472 2.02017 20.9829 1.99978 22.0362C1.91925 23.5456 2.3779 25.0344 3.29381 26.2368C4.20972 27.4392 5.52324 28.2769 6.99978 28.6002",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9998 17L15.1778 31.764C15.0851 31.873 15.0255 32.0062 15.006 32.148C14.9865 32.2898 15.008 32.4341 15.068 32.5641C15.1279 32.694 15.2237 32.8041 15.3442 32.8814C15.4647 32.9586 15.6047 32.9998 15.7478 33H20.9998V45L32.8218 30.238C32.9146 30.1289 32.9743 29.9955 32.9937 29.8535C33.0131 29.7116 32.9914 29.567 32.9312 29.437C32.871 29.307 32.7749 29.1969 32.6541 29.1198C32.5334 29.0427 32.3931 29.0019 32.2498 29.002H26.9998V17Z",
    fill: "#0258FF",
    stroke: "#0258FF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCloudFlash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cloud-flash.1ed6d23b.svg";
export { ForwardRef as ReactComponent };